export const checkEmailIsValid = (email: string): boolean => {
    const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])/;
    return emailRegex.test(email);
};

export const stringFormat = (str: string = '', ...rest: any[]): string => {
    if (!str || typeof str !== 'string') return '';
    return str.replace(/{(\d+)}/g,(match,number)=>{
        return typeof rest[number] !== 'undefined' ? rest[number] : match
    });
};
